/**
 * Anonymous visitors of the sign-in page are sent straight to the configured
 * Voxa SSO. `?sso=off` (set after a failed or declined SSO attempt) keeps the
 * normal Google/password form so a failure can never loop.
 */
export function shouldAutoStartSso(mode: string, search: string) {
  return mode === "sign in" && new URLSearchParams(search).get("sso") !== "off";
}

export function ssoAutoStartUrl(tenantId: string, nextPath: string) {
  return `/api/v1/auth/sso/${encodeURIComponent(
    tenantId,
  )}/login?${new URLSearchParams({ returnTo: nextPath }).toString()}`;
}
